import React from 'react';
import { SkillsPage } from './components/SkillsPage';

import './index.scss';

export default function Skills() {
  return <SkillsPage />;
}
